import { batch, connect } from 'react-redux';
import { selectIsFeatureFlagVariation } from '@noths/polaris-client-user-configuration';

import { actions as filterMenuActions } from 'src/components/organisms/FilterMenu/modules/slice';
import { SORT_FILTER_UID } from 'src/constants/elementIds';
import { FacetedSearch } from 'src/constants/featureFlags';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { AppThunkDispatch } from 'src/redux/store';
import { Filter, SelectedFilterOption, SortOptionValue } from 'src/types';
import {
  updateFilters,
  UpdateFiltersActionType,
} from '../../../../redux/products/thunks/updateFilters';
import { FilterOptions } from '../components/FilterOptions';
import { onExpandableContentToggle } from '../modules/actions';
import { getFilterOptionsWithoutNullActiveCounts } from '../modules/selectors/selectorHelpers';
import { actions as filterActions } from '../modules/slice';
import { ExpandableContentTogglePayload } from '../types';

export const mapStateToProps = (
  state: ReduxApplicationState,
  ownProps: { filter: Filter; isExpanded?: boolean },
) => {
  const isFacetedSearchVariant = selectIsFeatureFlagVariation(
    state,
    FacetedSearch.NAME,
    FacetedSearch.VARIANT_FACETED_SEARCH,
  );

  const filterWithoutActiveCounts = {
    ...ownProps.filter,
    options: getFilterOptionsWithoutNullActiveCounts(ownProps.filter.options),
  };

  return {
    currencyCode: state.products.currencyCode,
    filter: isFacetedSearchVariant ? ownProps.filter : filterWithoutActiveCounts,
    isExpanded: ownProps.isExpanded,
    selectedFilterOptions: state.filter.collections.selectedFilterOptions,
  };
};

export const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onSelectFilterOption: (selectedFilterOption: SelectedFilterOption) => {
    batch(() => {
      const sortOptionSelected = selectedFilterOption.filterUid === SORT_FILTER_UID;

      if (sortOptionSelected) {
        /*
          When sort options are being used as filter options we need to ensure the sorting options state keeps in sync with the sort filter.
          We need to do that as the submission logic in the thunk looks at the original sorting options when sending params to the API and
          also keeps the UI in sync if the user suddenly goes to a desktop view and sees the original sort drop down (since this feature we are doing is only for MW & TA).
         */
        dispatch(
          filterMenuActions.selectSortOption(
            selectedFilterOption.filterOptionValue as SortOptionValue,
          ),
        );
      }

      dispatch(filterActions.selectFilterOption(selectedFilterOption));
      dispatch(
        updateFilters(
          sortOptionSelected ? UpdateFiltersActionType.SORT : UpdateFiltersActionType.FILTER,
        ),
      );
    });
  },
  onExpandableContentToggle: (payload: ExpandableContentTogglePayload) =>
    dispatch(onExpandableContentToggle(payload)),
});

export const FilterOptionsContainer = connect(mapStateToProps, mapDispatchToProps)(FilterOptions);
